import { render, staticRenderFns } from "./BellButton.vue?vue&type=template&id=2b178b4e"
import script from "./BellButton.vue?vue&type=script&lang=js"
export * from "./BellButton.vue?vue&type=script&lang=js"
import style0 from "./BellButton.vue?vue&type=style&index=0&id=2b178b4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports